/** Capitaliza la primera letra y pasa el resto a minúsculas. */
export const toSentenceCase = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);
